module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedThin.143e767.ttf";